import template from './creditCards.html';

export default {
  template,
  controllerAs: 'vm',
  bindings: {
    cardType: '<',
  },
};
